import { ReloadOutlined } from '@ant-design/icons';
import { Inventory } from '@hefe/models';
import { InventoryApi } from '@hefe/store';
import { Button } from 'antd';
import { useLocation, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../../store/store';
import CustomList from '../../../core/components/custom-list/custom-list.component';
import InventoryShareDetailsModalComponent from '../../components/inventory-share-details-modal/inventory-share-details-modal.component';
import UserInventoryListItemComponent from '../../components/user-inventory-list-item/user-inventory-list-item.component';

export default function UserInventoriesPage() {
  const { transferId } = useParams();
  const { state } = useLocation();
  const dispatch = useAppDispatch();

  const {
    data,
    isFetching: isFetchingInventory,
    refetch,
  } = InventoryApi.useFetchUserInventoriesQuery();

  return (
    <>
      <CustomList
        id="user-inventories"
        extra={
          <Button.Group>
            <Button icon={<ReloadOutlined />} onClick={() => refetch()} />
          </Button.Group>
        }
        dataSource={data ?? []}
        loading={isFetchingInventory}
        renderItem={(inventory: Inventory) => (
          <UserInventoryListItemComponent
            key={inventory.id}
            inventory={inventory}
          />
        )}
      />
      <InventoryShareDetailsModalComponent shareId={transferId} />
    </>
  );
}
